import React from 'react';
import { IncubatorCardRow } from './incubatorCardRow.jsx';
import { createUrlForPortfolioTab } from '../utils.js';

export default class ListPane extends React.Component{
   constructor(props) {
      super(props);
   }
 
   render() {
      if(!this.props.cards){
         console.log('card list does not exist');
         return(<div />);
      } else if(this.props.cards.length === 0){
         return(<div />);
      }
      let cards = this.props.cards.slice();
      let cardRows = cards.filter(card => {
         return !(this.props.portfolioCardMap && (this.props.portfolioCardMap.has(card.id)))
      }).map((card,index) => {
         return (
            <IncubatorCardRow
               cardType={card.cardType}
               card={card}
               key={card.cardType + '_' + card.id + '_' + index}
               linkFunction={() => this.props.linkFunction(card)}
               linkBase={createUrlForPortfolioTab(this.props.tab)}
               allApproved={true}
               showAddButton={this.props.showAddButton}
               idPortfolio={this.props.idPortfolio}
               portfolioName={this.props.portfolioName}
               getUpdatedPortfolioData={this.props.getUpdatedPortfolioData}
               addCardFunction={this.props.addCardFunction}
            />
         );
      });
      return (
         <div id='portfolioCardRows' className={'list-pane'}>
            {cardRows}
         </div>
      );
   }   
}